import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Modal, Theme } from '../../../components';
import { ExitReason } from '../../../models';

interface Props {
  onSelect: (reason: ExitReason) => void;
  isOpen: boolean;
  close: () => void;
}

const FoodStatusModal: FC<Props> = ({ isOpen, close, onSelect }) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} title={t('lblEditFoodStatus')} closeModal={() => close()}>
      <p>{t('lblWhatHappened')}</p>
      <div className='buttons row-buttons'>
        <Button theme={Theme.SECONDARY} onClickCallback={() => onSelect(ExitReason.WASTE)}>
          {t('lblWasteReason')}
        </Button>
        <Button theme={Theme.SECONDARY} onClickCallback={() => onSelect(ExitReason.EMPTY)}>
          {t('lblEmptyReason')}
        </Button>
        <Button theme={Theme.INVERSE} onClickCallback={close}>
          {t('lblCancel')}
        </Button>
      </div>
    </Modal>
  );
};

export default FoodStatusModal;
